module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_c('em', [_vm._v("Author’s foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "lb-db"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_vm._v("GETTING STARTED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_vm._v("What is pruning?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Philosophy of pruning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_vm._v("Plant groups and treatments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Tackling neglected gardens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec5"
    }
  }, [_vm._v("Equipment you will need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec6"
    }
  }, [_vm._v("Preparing plants for planting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec7"
    }
  }, [_vm._v("Making the right cut")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "id": "f0001-01",
      "src": "images/f0001-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "org-dorg"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("SHRUBS, TREES AND CLIMBERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy of pruning shrubs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy of pruning trees")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy of pruning climbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A–Z of pruning shrubs, trees and climbers")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "id": "f0001-02",
      "src": "images/f0001-02.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gr-dgr"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("HEDGES AND CONIFERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foliage hedges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flowering hedges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conifers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forming arches and tunnels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topiary")])])]), _vm._v(" "), _c('div', {
    staticClass: "vio-dvio"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("ROSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patio and miniature roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rose hedges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standard roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrub roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climbing roses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rambling roses")])])]), _vm._v(" "), _c('div', {
    staticClass: "bu-dbu"
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("FRUIT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apples")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plums")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peaches and nectarines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raspberries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blackberries, hybrid berries and loganberries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black currants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red and white currants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gooseberries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grape vines")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Glossary")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 57
// module chunks = 0